import type {UserConsents} from '@/ts/types/dto/user-dto';

/** Returns true only when both productImprovement and analyticsAnonymized consents are approved */
export function shouldEnableAnalytics(consents: UserConsents | null | undefined): boolean {
  return (consents?.productImprovement?.approved ?? false)
    && (consents?.analyticsAnonymized?.approved ?? false);
}
